module.exports = __webpack_public_path__ + "img/qingxulijie.8e482499.png";